import { Helmet } from "react-helmet-async";
 import  {CourseSummaryListViewReport}  from "../../../sections/company/report/courseSummary/index.js";

export default function CourseSummaryListViewReportPage(){
    return (
        <>
            <Helmet>
                <title>Course Summary Report Page</title>
            </Helmet>
            <CourseSummaryListViewReport />
        </>
    )
}